import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { checkToken, submitPassword } from "../api/authReset";
import { useApiError } from "../hooks/useApiError";
import { AuthShell } from "../features/auth/AuthShell";
import { SetPasswordForm } from "../features/auth/SetPasswordForm";
import "./PaymentResultPage.css";

// Handles both /reset-password?token=… and /accept-invite?token=…
export default function SetPasswordPage({ mode = "reset" }) {
  const { t } = useTranslation();
  const describe = useApiError();
  const token = useSearchParams()[0].get("token") || "";
  const [state, setState] = useState({ status: "checking", email: "", error: "", busy: false });

  useEffect(() => {
    checkToken(mode, token)
      .then(({ data }) => setState((s) => ({ ...s, status: "ready", email: data.email })))
      .catch(() => setState((s) => ({ ...s, status: "invalid" })));
  }, [mode, token]);

  const save = async (password) => {
    setState((s) => ({ ...s, busy: true, error: "" }));
    try {
      await submitPassword(mode, token, password);
      window.location.replace("/app-ready");
    } catch (err) {
      setState((s) => ({ ...s, busy: false, error: describe(err) }));
    }
  };

  const titles = { reset: t("reset.newTitle"), invite: t("staff.acceptTitle") };
  return (
    <div className="payment-success-light bg-background text-foreground">
      <AuthShell title={titles[mode]} subtitle={state.email || undefined} testId={`${mode}-card`}>
      {state.status === "checking" ? <p className="mt-6 text-sm text-muted-foreground">{t("app.loading")}</p> : null}
      {state.status === "invalid" ? (
        <p className="mt-6 text-sm font-semibold text-destructive" data-testid="token-invalid">
          {t("reset.invalidLink")}
        </p>
      ) : null}
      {state.status === "ready" ? <SetPasswordForm onSubmit={save} busy={state.busy} error={state.error} /> : null}
      <Link to="/login" className="mt-5 block text-center text-xs font-semibold text-primary" data-testid="set-back">
        {t("reset.backToLogin")}
      </Link>
      </AuthShell>
    </div>
  );
}
